import { FC } from 'react';
// components
import AddSandComponentForm from 'components/main/SandComponent/Edit';

const AddSandComponent: FC = () => <AddSandComponentForm />;

export default AddSandComponent;
